import { CustomDictPos } from '#/protobuf/bareun/revision_service_pb';
import { SelectItemType } from 'types/common';

export const allDictPos = 9999;
export const DICT_NAME = [
  { label: '고유명사', value: 'np' },
  { label: '복합명사', value: 'cp' },
  {
    label: '복합명사 분리용',
    value: 'cpc'
  },
  { label: '동사', value: 'vv' },
  { label: '형용사', value: 'va' }
] as const;

export const ChangeDictName = (type: string) => {
  const item = DICT_NAME.find((e) => e.value === type);
  if (item) {
    return item.label;
  }
};

export const typeList: {
  label: string;
  value: number;
  countKey?: keyof dictSetType;
}[] = [
  { label: '전체', value: allDictPos },
  { label: '고유명사', value: CustomDictPos.POS_NNP, countKey: 'np_set' },
  { label: '복합명사', value: CustomDictPos.POS_NNG, countKey: 'cp_set' },
  {
    label: '복합명사 분리용',
    value: CustomDictPos.POS_NNG_CARET,
    countKey: 'cp_caret_set'
  },
  { label: '동사', value: CustomDictPos.POS_VV, countKey: 'vv_set' },
  { label: '형용사', value: CustomDictPos.POS_VA, countKey: 'va_set' }
  // { label: '관형사', value: CustomDictPos.POS_MM, countKey: 'mm_set' },
  // { label: '부사', value: CustomDictPos.POS_MAG, countKey: 'mag_set' },
  // { label: '감탄사', value: CustomDictPos.POS_IC, countKey: 'ic_set' }
];

export const dictTypeList: {
  label: string;
  value: number;
  countKey?: keyof dictSetType;
}[] = [
  { label: '고유명사', value: CustomDictPos.POS_NNP, countKey: 'np_set' },
  { label: '복합명사', value: CustomDictPos.POS_NNG, countKey: 'cp_set' },
  {
    label: '복합명사 분리용',
    value: CustomDictPos.POS_NNG_CARET,
    countKey: 'cp_caret_set'
  },
  { label: '동사', value: CustomDictPos.POS_VV, countKey: 'vv_set' },
  { label: '형용사', value: CustomDictPos.POS_VA, countKey: 'va_set' }
  // { label: '관형사', value: CustomDictPos.POS_MM, countKey: 'mm_set' },
  // { label: '부사', value: CustomDictPos.POS_MAG, countKey: 'mag_set' },
  // { label: '감탄사', value: CustomDictPos.POS_IC, countKey: 'ic_set' }
];

export interface dictType {
  id: string;
  value: string;
  type: number;
}

export interface dictSetType {
  np_set: dictType[];
  cp_set: dictType[];
  cp_caret_set: dictType[];
  vv_set: dictType[];
  va_set: dictType[];
  mm_set: dictType[];
  mag_set: dictType[];
  ic_set: dictType[];
}

const FORBIDDEN_SYMBOLS_REGEX =
  /[\s'"()\[\]｀{}˝‘’“”′″〈〉《》｢「｣」『』【】〔〕<＜>＞≪≫!,.:;·˙‧∙，/／：；․…‥?.？．]/;

export function validateDictWord(word: string): string | null {
  if (!word || word.trim().length === 0) {
    return '빈 문자열은 추가할 수 없습니다.';
  }
  if (/\s/.test(word)) {
    return '공백은 포함될 수 없습니다.';
  }
  if (FORBIDDEN_SYMBOLS_REGEX.test(word)) {
    return '사전 단어에 사용할 수 없는 기호가 포함되어 있습니다.';
  }
  return null;
}

export function changeDictKorName(name: number) {
  switch (name) {
    case CustomDictPos.POS_UNK:
      return '알수없음';
    case CustomDictPos.POS_NNG:
      return '복합명사';
    case CustomDictPos.POS_NNP:
      return '고유명사';
    case CustomDictPos.POS_NNG_CARET:
      return '복합명사 분리용';
    case CustomDictPos.POS_VV:
      return '동사';
    case CustomDictPos.POS_VA:
      return '형용사';
    case CustomDictPos.POS_MM:
      return '관형사';
    case CustomDictPos.POS_MAG:
      return '부사';
    case CustomDictPos.POS_IC:
      return '감탄사';
    default:
      return '알수없음';
  }
}

const targetKorNames = ['고유명사', '복합명사', '복합명사 분리용'];

export const customDictPosFilteredSelectItems: SelectItemType[] =
  Object.entries(CustomDictPos)
    // protobuf-es 의 CustomDictPos 는 TS 숫자 enum 이라 역방향 매핑(0 → 'POS_...')까지
    // 함께 열거된다. 종전 jspb 는 이름 → 번호 한 방향뿐이었으므로 숫자 값만 남긴다.
    .filter(([, value]) => typeof value === 'number')
    .map(([label, value]) => ({
      label: changeDictKorName(value as number),
      value: value.toString()
    }))
    .filter((item) => targetKorNames.includes(item.label));
